module.exports = __webpack_public_path__ + "img/ic_liveticker_finish.f7f21dc5.svg";